import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormGroup } from "@angular/forms";
import { ENV } from "@app/env";
import { Store } from "@ngrx/store";
import { ModalController, NavParams, ToastController, ViewController } from "ionic-angular";
import { Subscription } from "rxjs/Subscription";
import { ClientData } from "../../../../providers/client";
import { GenFormBuilder } from "../../../../providers/form";
import { Utilities } from "../../../../providers/utilities";
import { IClient } from "../../../../shared/models/client.model";
import { IProfileUsers } from "../../../../shared/models/profile-users.model";
import * as sharedSelectors from "../../../../shared/reducers/shared.reducer";
import { FormQuestionComponent, IQuestionOption } from "../form-question/form-question.component";

@Component({
  selector: "app-form-users-form",
  templateUrl: "form-users-form.component.html",
})

export class FormUsersFormComponent implements OnInit, OnDestroy {

  public client: IClient;
  public clientId: string;
  public clientSubscribe: Subscription;
  public defaultLanguage: string;
  public form: FormGroup;
  public language: string;
  public languageMenu: "en" | "es" = "es";
  public profile: IProfileUsers;
  public production = ENV.mode === "Production";
  public submitAttempt: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private genForm: GenFormBuilder,
    private utilities: Utilities,
    private clientData: ClientData,
    private toastController: ToastController,
    public viewCtrl: ViewController,
    private store: Store<{}>,
    private navParams: NavParams,
    private modalCtrl: ModalController,
  ) { }

  public ngOnInit() {
    this.clientId = this.navParams.get("clientId");
    this.profile = this.navParams.get("form");
    this.clientSubscribe = this.store.select(sharedSelectors.getClient).subscribe((client) => {
      if (client) {
        this.client = client;
        this.defaultLanguage = client.defaultLanguage;
        this.language = this.defaultLanguage;
        this.buildForm();
      }
    });
  }

  public createFormQuestionInstance(question: any) {
    const instance = FormQuestionComponent.prototype;
    instance.formBuilder = this.formBuilder;
    instance.navParams = new NavParams({ options: question.data.options });
    instance.genForm = this.genForm;
    return instance;
  }

  public async onFormSubmitted({ value, valid }: { value: any; valid: boolean }) {
    this.submitAttempt = true;
    if (valid) {
      const load = this.utilities.setLoading();
      await this.clientData.createFormUsers(this.clientId, value);
      await this.toastController.create({
        duration: 3000,
        message: "The form was succesfully update",
      }).present();
      await this.viewCtrl.dismiss();
      load.dismiss();
    }
  }

  public addQuestion() {
    const modal = this.modalCtrl.create(FormQuestionComponent);
    modal.present();
    modal.onDidDismiss((data) => {
      if (data) {
        const questions = this.form.get("questions") as FormArray || this.formBuilder.array([]);
        questions.push(data);
        this.form.addControl("questions", questions);
      }
    });
  }

  public editQuestion(question: FormGroup, i: number) {
    // console.log("Edit question: ", question.value);
    const modal = this.modalCtrl.create(FormQuestionComponent, { question });
    modal.present();
    modal.onDidDismiss((data) => {
      if (data) {
        // console.log("Question edited: ", data.value);
        const questions = this.form.get("questions") as FormArray;
        questions.setControl(i, data);
      }
    });
  }

  public removeQuestion(i: number) {
    const questions = this.form.get("questions") as FormArray;
    questions.removeAt(i);
  }

  public ngOnDestroy() {
    if (this.clientSubscribe) { this.clientSubscribe.unsubscribe(); }
  }

  private buildForm() {
    this.form = this.formBuilder.group({});
    this.genForm.genInputString("id", this.form);
    this.genForm.genInputLang("name", this.form, this.defaultLanguage);
    this.genForm.genInputString("type", this.form, true);
    this.genForm.genToggle("state", this.form);
    const questions = this.formBuilder.array([]);
    this.form.addControl("questions", questions);
    this.patchForm();
  }

  private patchForm() {
    if (this.profile) {
      let questions = this.profile.questions || [];
      questions = questions.map((q) => {
        const formQuestionInstance = this.createFormQuestionInstance(q);
        const group = formQuestionInstance.initForm();
        formQuestionInstance.addDataControl(q.type, group);
        return group;
      });
      const arrayControl = this.formBuilder.array(questions);
      this.form.setControl("questions", arrayControl);
      this.form.patchValue(this.profile);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/form-users/components/form-users-form/form-users-form.component.ts